import React from 'react';
import styled from 'styled-components';
import moment from 'moment';
import Form from '../../CommonComponents/Form';
import Label from '../../CommonComponents/Label';
import TransactionCategoryPopup from '../../CommonComponents/ModalListPicker';
import { StyledButton as Button } from '../../CommonComponents/Button';

const Wrapper = styled.div`
  flex-grow: 1;
  padding: 30px;
  box-shadow: inset 0 0 4px 0 rgba(0, 0, 0, 0.26);
`;

const TransactionButton = styled(Button)`
  border-bottom: 1px solid rgba(151, 151, 151, 0.23);
  padding-left: 0;
  text-align: left;
  width: 100%;
`;

const SaveButton = styled(Button)`
  width: 100%;
`;

class MobileEditTransaction extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isCategoryPickerModalOpen: false,
    };

    this.openCategoryPickerModal = this.openCategoryPickerModal.bind(this);
    this.closeCategoryPickerModal = this.closeCategoryPickerModal.bind(this);
  }

  componentDidMount() {
    const { scrollMobileToTop } = this.props;

    scrollMobileToTop();
  }

  openCategoryPickerModal() {
    this.setState({ isCategoryPickerModalOpen: true });
  }

  closeCategoryPickerModal() {
    this.setState({ isCategoryPickerModalOpen: false });
  }

  render() {
    const {
      transaction, expenseCategoryOptions, onChange, onSave,
    } = this.props;

    const transactionDate = moment
      .utc(`${transaction.month}-${transaction.day}-${transaction.year}`, 'M-D-YYYY')
      .format('MMMM Do YYYY');

    return (
      <Wrapper>
        <Form.Control>
          <Label>Transaction Category</Label>
          <TransactionButton onClick={this.openCategoryPickerModal}>
            {transaction.category}
          </TransactionButton>

          <TransactionCategoryPopup
            hasHeader={false}
            isOpen={this.state.isCategoryPickerModalOpen}
            onRequestClose={this.closeCategoryPickerModal}
            options={expenseCategoryOptions}
            value={transaction.category}
            onChange={category => onChange({ ...transaction, category })}
          />
        </Form.Control>
        <Form.Control>
          <Label>Transaction Date</Label>
          <div>{transactionDate}</div>
        </Form.Control>
        <Form.Control>
          <Label>Description</Label>
          <div>{transaction.description}</div>
        </Form.Control>
        <Form.Control>
          <Label>Amount</Label>
          <div>{transaction.amount}</div>
        </Form.Control>
        {transaction.account && (
          <Form.Control>
            <Label>Account name</Label>
            <div>{transaction.account.label}</div>
          </Form.Control>
        )}

        <SaveButton appearance="primary" onClick={onSave}>
          Save
        </SaveButton>
      </Wrapper>
    );
  }
}

export default MobileEditTransaction;
